import { render, staticRenderFns } from "./NewFranchiseManualSidebar.vue?vue&type=template&id=cbfdf9f6"
import script from "./NewFranchiseManualSidebar.vue?vue&type=script&lang=js"
export * from "./NewFranchiseManualSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports